module.exports = __webpack_public_path__ + "img/dynamic-2.5a2b3c87.png";